import { useEffect } from "react"
import theme from "lib/material-ui/theme"
import { ITEM } from "constants/index"
import { PremiumSlide } from "types/premium.types"
import { PATH_INFOS } from "utils/navigatorUtils"
import { useAppSelector } from "appRedux/hooks"

export default function useMetaTags() {
  const currentPageInfo = useAppSelector((state) => state.global.currentPageInfo)
  const showShareProfileModal = useAppSelector((state) => state.global.showShareProfileModal)
  const wishListState = useAppSelector((state) => state.wishList)
  const showPremiumOnboarding = useAppSelector((state) => state.premium.showPremiumOnboarding)
  const currentPremiumOnboardingSlide = useAppSelector((state) => state.premium.currentPremiumOnboardingSlide)
  const PREMIUM_SLIDES_FOR_ACTIVE_FEATURES = useAppSelector((state) => state.premium.premiumSlidesForActiveFeatures)

  useEffect(() => {
    updateThemeColor(currentPageInfo?.path)
  }, [currentPageInfo?.path, wishListState.viewMode, showPremiumOnboarding, currentPremiumOnboardingSlide, showShareProfileModal])

  function updateThemeColor(path: string) {
    let metaThemeColor = document.querySelector("meta[name='theme-color']")

    if (!metaThemeColor) {
      metaThemeColor = document.createElement("meta")
      metaThemeColor.setAttribute("name", "theme-color")
      document.head.appendChild(metaThemeColor)
    }

    const themeColor = getThemeColor(path)
    metaThemeColor.setAttribute("content", themeColor)
  }

  function getThemeColor(path: string) {
    if (showPremiumOnboarding) {
      return getThemeForPremiumOnboarding(currentPremiumOnboardingSlide, PREMIUM_SLIDES_FOR_ACTIVE_FEATURES)
    }

    if (showShareProfileModal) {
      return theme.palette.primary["5"] as string
    }

    switch (true) {
      case (path === PATH_INFOS.viewItem.path ||
        path === PATH_INFOS.viewItems.path ||
        (path === PATH_INFOS.viewList.path && wishListState.viewMode === ITEM)):
        return "#000000"
      default:
        return "#FFFFFF"
    }
  }
}

function getThemeForPremiumOnboarding(currentPremiumOnboardingSlide: number, slides: PremiumSlide[]) {
  let themeColor = slides[currentPremiumOnboardingSlide]?.theme === "light" ? theme.palette.primary["1"] : theme.palette.primary["8"]
  return themeColor || "#FFFFFF"
}
